import { useEffect, useState } from "react";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

import { auth } from "../config/firebase";
import { createUser, isUserExists } from "../database";

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

const useFirebaseAuth = () => {
  const [authUser, setAuthUser] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setAuthUser({
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          photoURL: user.photoURL,
        });
        setLoading(false);
      } else {
        setAuthUser(null);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const logInWithGoogle = async () => {
    setLoading(true);
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      const isExist = await isUserExists(user?.email);
      if (!isExist) {
        await createUser({
          uid: user.uid,
          name: user.displayName,
          authProvider: "google",
          email: user.email,
          photoUrl: user.photoURL,
        });
      }
    } catch (error: any) {
      window.alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const logOut = async () => {
    setLoading(true);
    try {
      await signOut(auth);
    } catch (error: any) {
      window.alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    logInWithGoogle,
    logOut,
    authUser,
    loading,
  };
};

export default useFirebaseAuth;
